import React from "react";
import { Employee } from "../api/generated/models/Employee";

interface EmployeeSearchTableProps {
  employees: Employee[];
  itemsPerPage: number;
  navigator: (id: number) => void;
}

const determinePageNumbers = (
  totalItems: number,
  itemsPerPage: number,
): number[] => {
  const pageNumbers: number[] = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return pageNumbers;
};

export const EmployeeSearchTable = (props: EmployeeSearchTableProps) => {
  const totalPages = determinePageNumbers(
    props.employees.length,
    props.itemsPerPage,
  );
  const [currentPage, setCurrentPage] = React.useState(0);

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Voornaam</th>
            <th>Achternaam</th>
            <th>Geboortedatum</th>
            <th>Bandjes</th>
            <th>Coordinator</th>
            <th>Rol</th>
          </tr>
        </thead>
        <tbody>
          {props.employees
            .slice(
              currentPage * props.itemsPerPage,
              (currentPage + 1) * props.itemsPerPage,
            )
            .map((employee) => (
              <tr
                key={employee.id}
                onClick={() => props.navigator(employee.id!)}
                className="hover:bg-base-300 cursor-pointer"
              >
                <td>{employee.firstName}</td>
                <td>{employee.lastName}</td>
                <td>{employee.birthDate}</td>
                <td>{employee.straps?.join(", ")}</td>
                <td>{employee.coordinator}</td>
                <td>{employee.role}</td>
              </tr>
            ))}
        </tbody>
      </table>
      {props.employees.length > props.itemsPerPage && (
        <div className="join mt-4">
          {totalPages.map((page) => (
            <button
              key={page}
              type="button"
              className={`join-item btn ${currentPage + 1 === page ? "btn-active" : ""}`}
              onClick={() => setCurrentPage(page - 1)}
            >
              {page}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
